const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#999;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-480.256 -89.893)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(480.256 89.893)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M480.894,105.893a.639.639,0,0,1-.451-1.09L495.166,90.08a.638.638,0,0,1,.9.9l-14.723,14.723A.636.636,0,0,1,480.894,105.893Z",
  transform: "translate(-480.256 -89.893)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(480.256 89.893)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M495.618,105.893a.636.636,0,0,1-.451-.187L480.443,90.983a.638.638,0,0,1,.9-.9L496.069,104.8a.639.639,0,0,1-.452,1.09Z",
  transform: "translate(-480.256 -89.893)"
})));
function SvgBorrar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrar);
export default __webpack_public_path__ + "static/media/borrar.e15203f816fed6f4e904e44ba09ced7c.svg";
export { ForwardRef as ReactComponent };